import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import cn from "classnames";

import Web3 from "web3";
import BigNumber from "bignumber.js";

import nftAbi from "../../abis/ArbiApeClubERC721.json";
import mintAbi from "../../abis/ArbiApeClub.json";

import { referralCodeToAccount } from "../Refs/utils";
import Connect from "../Connect";
import s from "./style.css";
import sU from "../utils.css";

// dev
// const rpc = "https://rinkeby.arbitrum.io/rpc";
// const mintAddress = "0x6c933164bc8F752B885Fd8B105Ea1F34f83a88c8";
// const nftAddress = "0xC1C87A24A77EafE1fa2E8009DCAF8cFfEB6C9cC7";
// const defaultRef = "0x6c933164bc8F752B885Fd8B105Ea1F34f83a88c8";
// const mainChainIds = [421611, "0x66eeb"];

// prod
const rpc = "https://arb1.arbitrum.io/rpc";
const mintAddress = "0xfaA928BDAdD0Ee68827fBA6e321efDA650923da0";
const nftAddress = "0xaf730246e5d2c32985f47425aeecc46f5b0a94a5";
const defaultRef = "0xcb7114e364bEA59dDeEfdFA4B869787D4318A3aF";
const mainChainIds = [42161, "0xa4b1"];

function addMainnetNetwork(provider) {
  provider.request({
    method: "wallet_addEthereumChain",
    params: [
      {
        chainId: "0xa4b1",
        chainName: "Arbitrum One",
        nativeCurrency: {
          name: "Ethereum",
          symbol: "AETH",
          decimals: 18,
        },
        rpcUrls: ["https://arb1.arbitrum.io/rpc"],
        blockExplorerUrls: ["https://arbiscan.io"],
      },
    ],
  });
}

export default function ({
  chainId,
  error,
  provider,
  account,
  connect,
  refId,
  class: className,
}) {
  const [price, setPrice] = useState(0);
  const [counter, setCounter] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [mineIds, setMine] = useState([]);

  const web3 = new Web3(provider || rpc);
  const Nft = new web3.eth.Contract(nftAbi, nftAddress);
  const Mint = new web3.eth.Contract(mintAbi, mintAddress);

  const refAccount = refId ? referralCodeToAccount(refId) : defaultRef;

  const correctChainId = chainId && mainChainIds.includes(chainId);

  async function retrievePublicData() {
    const pr = await Mint.methods.price().call();
    const maxSupply = await Nft.methods.maxSupply().call();
    const totalSupply = await Nft.methods.totalSupply().call();

    setCounter(maxSupply - totalSupply);
    setPrice(web3.utils.fromWei(pr));

    if (account) {
      const ids = await Nft.methods.getOwnerNFTs(account).call();
      const idsToJson = ids.map((id) => ({ id }));

      setMine(idsToJson);
    }
  }

  useEffect(
    async function () {
      const id = setInterval(retrievePublicData, 10000);
      retrievePublicData();

      return () => clearInterval(id);
    },
    [account]
  );

  async function mint(e) {
    e.preventDefault();

    const value = new BigNumber(web3.utils.toWei(price)).multipliedBy(
      Number(quantity)
    );

    await Mint.methods
      .mint(refAccount)
      .send({ from: account, value, gas: 1300000 + 2000000 * quantity });
  }

  return (
    <div class={className}>
      <div class={s.wrapper}>
        <form class={s.form} onSubmit={mint}>
          {!correctChainId && (
            <p class={s.heading}>
              <button onClick={() => addMainnetNetwork(provider)}>
                Switch
              </button>{" "}
              to Arbitrum
            </p>
          )}

          {correctChainId && (
            <>
              <p class={s.heading}>MINT AN APE</p>
              <p class={cn(s.heading, sU.hiddenOnlyMd)}>
                {counter || "-"} remaining
              </p>
            </>
          )}
          <div>
            <input
              type="number"
              class={s.quantityInput}
              placeholder="quantity"
              value={quantity}
              onInput={(e) => setQuantity(e.target.value)}
            />
            {account && (
              <button type="submit" class={s.buttonMint}>
                Mint (
                {price && quantity ? (price * quantity).toFixed(2) : "0.00"}{" "}
                ETH)
              </button>
            )}

            {!account && <Connect class={s.buttonMint} connect={connect} />}
          </div>
        </form>

        {/* {error && error == 4001 && (
        <p class="alert">Transaction denied, try again.</p>
      )} */}

        {/* <ul id="mine">
        {mineIds.map(({ image, id }) => (
          <li>
            <img src={image} alt={`Mixmoji #${id}`} /> 
            <h4>Mixmoji #{id}</h4>
          </li>
        ))}
      </ul> */}
      </div>
      <div>
        {account && (
          <>
            {mineIds.length > 0 && (
              <p class="owning">
                You own <strong>{mineIds.length}</strong> ArbiApes
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
